export default __webpack_public_path__ + "static/media/weekly_xp_icon.53358e31.svg";